import { useQuery } from "react-query";
import { getCalendar } from "@/api";

export const useClientCalendar = () => {
  return useQuery(["client_calendar"], getCalendar);
};
